import { HOMEPAGE_SERVICES } from 'shared/experiments/consts'
import { PAGE_TYPE_HOMEPAGE } from 'shared/consts'

import store from 'shared/store'
import {
  bindTrackingEvents,
  isExperimentEnabled,
  trackEvent
} from 'views/assets/scripts/optimizely'
import { event } from 'shared/experiments/utils'

const bindEventsTracking = () => {
  bindTrackingEvents([
    {
      selector: '.e-ServiceLinksContainer .o-IconLinksList__Link',
      event: 'click',
      trackingEvent: event`Services Links - click`
    }
  ])

  const banner = document.querySelector(
    '[data-clientside-hook~="ServicesWidgetBanner"] [data-banner]'
  )
  if (banner) {
    banner.addEventListener('click', clickEvent => {
      const target = <HTMLElement>clickEvent.target
      trackEvent(
        event`Services Links - banner ${<string>target.dataset.banner}`
      )
    })
  }
}

export default () => {
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { pageType } = publicRuntimeConfig?.pageProperties || {}

  if (
    !(isExperimentEnabled(HOMEPAGE_SERVICES) && pageType === PAGE_TYPE_HOMEPAGE)
  ) {
    return
  }

  bindEventsTracking()
}
